import React from "react";
import { FileBarChart2, Search } from "lucide-react";

const ReportDetailEmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-16 bg-white border border-dashed border-gray-300 rounded-lg flex-1 min-h-[500px]">
      <div className="flex items-center justify-center w-20 h-20 rounded-2xl bg-slate-100 mb-6 shadow-inner">
        <FileBarChart2 className="w-9 h-9 text-slate-400" />
      </div>
      <div className="max-w-md w-full mx-auto">
        <h2 className="text-lg font-medium text-gray-600 mb-2 tracking-tight">Select an Entity</h2>
        <p className="text-sm text-gray-500 m-0 leading-relaxed">
          Search for an institution, faculty member, or unit above to view their detailed
          metrics report — publications, citations, research areas, collaborations and more.
        </p>
      </div>
    </div>
  );
};

export default ReportDetailEmptyState;
